/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { SignInProps, HeaderProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SignInPageService";
const log: any = LoggerModule.getInstance();

export class SignInPageService {
  private static instance: SignInPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: HeaderProps;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): SignInPageService {
    if (!SignInPageService.instance) {
      SignInPageService.instance = new SignInPageService(props);
    }
    return SignInPageService.instance;
  }

  public async signInUser(args: SignInProps) {
    log.info(`user SignIn`, args);
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getSignInUser(_args);
  }
}
